import { useEffect, useRef } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuthStore } from '@/store/auth'

// Importar páginas
import LoginPage from '@/pages/LoginPage'
import DashboardPage from '@/pages/DashboardPage'
import ConfigurationPage from '@/pages/ConfigurationPage'
import MonitoringPage from '@/pages/MonitoringPage'
import GridPage from '@/pages/GridPage'
import BacktestingPage from '@/pages/BacktestingPage'
import ControlPage from '@/pages/ControlPage'

// Importar componentes de layout
import Layout from '@/components/Layout'
import ProtectedRoute from '@/components/ProtectedRoute'
import LoadingScreen from '@/components/LoadingScreen'

function App() {
  const { isAuthenticated, isLoading, checkAuth } = useAuthStore()
  const hasInitialized = useRef(false)

  useEffect(() => {
    if (!hasInitialized.current) {
      hasInitialized.current = true
      checkAuth()
    }
  }, [])

  if (isLoading) {
    return <LoadingScreen />
  }

  return (
    <Routes>
      {/* Ruta de login */}
      <Route 
        path="/login" 
        element={
          isAuthenticated ? <Navigate to="/dashboard" replace /> : <LoginPage />
        } 
      />
      
      {/* Rutas protegidas */}
      <Route element={<ProtectedRoute />}>
        <Route element={<Layout />}>
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/configuration" element={<ConfigurationPage />} />
          <Route path="/monitoring" element={<MonitoringPage />} />
          <Route path="/grid" element={<GridPage />} />
          <Route path="/backtesting" element={<BacktestingPage />} />
          <Route path="/control" element={<ControlPage />} />
        </Route>
      </Route>

      {/* Redirección por defecto */}
      <Route 
        path="/" 
        element={
          <Navigate to={isAuthenticated ? "/dashboard" : "/login"} replace />
        } 
      />
      
      {/* Ruta 404 */}
      <Route 
        path="*" 
        element={
          <Navigate to={isAuthenticated ? "/dashboard" : "/login"} replace />
        } 
      />
    </Routes>
  )
}

export default App